import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import css from './CustomFilterSection.module.css';
import IconCollection from '../../../../components/IconCollection/IconCollection';
import BWLogo from '../../../../assets/BW_logo_mobile.png';
import { createResourceLocatorString } from '../../../../util/routes';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { ResponsiveImage } from '../../../../components';
import classNames from 'classnames';

const CustomFilterSection = () => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const handleClick = (pathname, pathParams) => {
    history.push(createResourceLocatorString(pathname, routeConfiguration, pathParams, {}));
  };

  return (
    <div className={css.customFilterContainer}>
      <div className={css.customFilterSection}>
        <div className={css.customFilterItem} onClick={() => handleClick('CreatorLandingPage', {})}>
          <div className={classNames(css.customFilterItemTitle, css.logoFilter)}>
            <ResponsiveImage url={BWLogo} alt={'BingeWorthy logo'} /> Creators
          </div>
        </div>
        <div className={classNames(css.customFilterItem)}
          onClick={() => handleClick('StreamsPage', {})}
        >
          <div className={css.customFilterItemTitle}>
            <IconCollection icon="icon-live-streams" />
            <div>
              <span>Live Streams</span>
            </div>
          </div>
        </div>
        <div className={classNames(css.customFilterItem)}
          onClick={() => handleClick('SeriesPage', {})}
        >
          <div className={css.customFilterItemTitle}>
            <IconCollection icon="icon-series-white" />
            <div>
              <span>Shows</span>
            </div>
          </div>
        </div>
        <div
          className={css.customFilterItem}
          onClick={() => handleClick('FilmsPage', {})}
        >
          <div className={css.customFilterItemTitle}>
            <IconCollection icon="icon-film-white" /> Movies
          </div>
        </div>
        <div
          className={css.customFilterItem}
          onClick={() => handleClick('PodcastsPage', {})}
        >
          <div className={css.customFilterItemTitle}>
            <IconCollection icon="icon-podcast-white" /> Podcasts
          </div>
        </div>
        <a
          className={classNames(css.customFilterItem, css.customFilterItemCreator)}
          href="https://bingeworthy.com/creator/@Studios/69e83cd5-589a-4e00-9dcc-81bbcbacb659"
        >
          <div className={classNames(css.customFilterItemTitle, css.creatorUniverse)}>
            <>
              <IconCollection icon="icon-live-white" />
              <span className={css.customFilterTitle}>BW Original</span>
            </>
          </div>
        </a>
      </div>
    </div>
  );
};

export default CustomFilterSection;
